// extracted by mini-css-extract-plugin
export default {"Arrow":"Arrow_Arrow__O4Knm","up":"Arrow_up__Ligpc","left":"Arrow_left__qhgj8","Arrows":"Arrow_Arrows__AspG9","right":"Arrow_right__hH50Y"};